import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {persistor} from "../store";

export const useLogoutCommand = (): ICommand => {
  const { addNoticeMessage } = useMessageLogic()

  return {
    help(): string {
      return '- logout\t\t\t\t:: logs out of the system';
    },

    async process(msg: string): Promise<void> {
      await persistor.purge()
      await persistor.flush()
      await persistor.persist()
      localStorage.clear()
      addNoticeMessage('logging out...')
      setTimeout(() => {
        window.location.reload()
      }, 500)

      return
    },

    matches(msg: string): boolean {
      return 'logout' === msg.toLowerCase().trim()
    }
  };
}